import { takeLatest } from 'redux-saga/effects';
import { FETCH_PRODUCT_DISPATCH } from '../../redux/modules/productDispatch/productDispatch-actions';
import { fetchProductDispatch } from './productDispatchWorkerSaga';

export function* fetchProductDispatchWatcher() {
    yield takeLatest(FETCH_PRODUCT_DISPATCH, fetchProductDispatch);
}

export default fetchProductDispatchWatcher;
